module.exports = __webpack_public_path__ + "static/media/PlayIcon.1181acf4.svg";